import {GetLogsDispatchTypes, GET_LOGS_FAIL, GET_LOGS_LOADING, GET_LOGS_SUCCESS} from './logsActionsTypes'


export interface LogsDefaultStateI {
    loading:boolean,
    logs?: any
}

const defaultState:LogsDefaultStateI = {
    loading:false
};


const logsReducer = (state: LogsDefaultStateI = defaultState,action:GetLogsDispatchTypes):LogsDefaultStateI =>{
    switch (action.type) {
        case GET_LOGS_FAIL:
            return {
                loading:false
            }
        case GET_LOGS_LOADING:
            return {
                loading:true
            }
        case GET_LOGS_SUCCESS:
            return {
                loading:false,
                logs:action.payload,
            }
        default:
            return state
    }
}


export default logsReducer;